import React, {
    useEffect,
    useState,
    useContext,
    useMemo
} from 'react';
import PropTypes from 'prop-types';
import DiscountsContext from "./DiscountsContext";
import AuthContext from "../AuthContext";
import axios from "axios";


const DiscountsContextProvider = ({
                                 children,
                             }) => {

        const {authToken} = useContext(AuthContext)
        const [discounts, setDiscounts] = useState(false)
        const [isReady, setIsReady] = useState(false);

        useEffect(() => {

                let shouldUpdate = true;

                const init = async () => {

                    let url = process.env.REACT_APP_BACK_SERVER + '/u/consultarAfinidades/descuentos'

                    axios.post(url, {}, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${authToken}`,
                        }
                    }).then((resp) => {
                        if (shouldUpdate) {
                            setDiscounts(resp['data']['afinidades_dict'])
                            setIsReady(true);
                        }

                    })
                }

                init();

                return () => {
                    /* This cleanup function is used to prevent updating the state
                    when the component is unmounted */
                    shouldUpdate = false;
                };
            }, []
        )

        const context = useMemo(() => ({
            discounts,
            isReady
        }), [
            discounts,
            isReady
        ]);
        return (
            <DiscountsContext.Provider value={context}>
                {children}
            </DiscountsContext.Provider>
        );
    }
;

DiscountsContextProvider.propTypes = {
    children: PropTypes.node.isRequired,
};

export default DiscountsContextProvider;